/*
 * @Author: your name
 * @Date: 2021-01-22 14:23:33
 * @LastEditTime: 2021-03-09 14:09:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\components\feedback\i18n.js
 */
export default {
  'zh-CN': {
    loading: '上传中...',
    addFile: '添加附件{n}MB',
    acceptFile: '最多支持上传{n}个文件',
    acceptFileSize: '单个文件不能大于{n}MB，请重新上传',
    feedback: '意见反馈',
    fillInformation: '请填写如下信息，方便我们与您联系，谢谢！',
    feedbackType: '反馈形式',
    realName: '实名反馈',
    anonymous: '匿名反馈',
    phone: '联系电话',
    tips: '请输入',
    title: '反馈标题',
    feedbackContent: '反馈内容',
    accessorys: '附件',
    cancel: '取 消',
    confirm: '确 认',
    uploadErrMsg: '文件选择错误，请重新选择，请上传大小50M以内文件',
    feedbackTypeTips: '请选择反馈形式',
    inputTips: '请输入{n}个字符以内！',
    feedbackTips: '请输入反馈内容',
    titleTips: '请输入反馈标题',
    correctPhone: '请输入正确的联系电话！',
    correctTips: '请填写正确信息',
    submitSuccess: '提交成功'
  },
  'en': {
    loading: 'Uploading…',
    addFile: 'Add attachment {n} MB',
    acceptFile: 'Up to {n} files can be uploaded',
    acceptFileSize: 'A single file cannot be greater than {n} MB, please upload again',
    feedback: 'Feedback',
    fillInformation: 'Please fill in the following information, so that we can contact you. Thank you!',
    feedbackType: 'Feedback form',
    realName: 'Real-name feedback',
    anonymous: 'Anonymous feedback',
    phone: 'Contact number',
    tips: 'Please enter',
    title: 'Feedback headline',
    feedbackContent: 'Feedback content',
    accessorys: 'Attachments',
    cancel: 'Cancel',
    confirm: 'Confirm',
    uploadErrMsg: 'File selection error, please select again and upload files no more than 50M',
    feedbackTypeTips: 'Please select a feedback form',
    inputTips: 'Please enter no more than {n} characters.',
    feedbackTips: 'Please enter feedback content',
    titleTips: 'Please enter a feedback headline',
    correctPhone: 'Please enter the correct contact number!',
    correctTips: 'Please fill in the correct information',
    submitSuccess: '提交成功'
  },
  'ja': {
  }
}
